"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskHelpers = void 0;
var types_1 = require("@bringg/types");
var lodash_1 = require("lodash");
var Tasks_consts_1 = require("./Tasks.consts");
var TaskHelpers = /** @class */ (function () {
    function TaskHelpers() {
    }
    TaskHelpers.isReadyToExecute = function (task) {
        return task.ready_to_execute;
    };
    TaskHelpers.isTaskInOpenState = function (task) {
        return (0, lodash_1.includes)(Tasks_consts_1.OPEN_TASK_STATUES, task.status);
    };
    TaskHelpers.isDone = function (task) {
        return (0, lodash_1.includes)(Tasks_consts_1.DONE_TASK_STATUES, task.status);
    };
    TaskHelpers.isGroupFollower = function (task) {
        return Boolean(task.group_leader_id);
    };
    TaskHelpers.isUnacknowledged = function (task) {
        return task.status === types_1.TaskStatus.Unacknowledged;
    };
    TaskHelpers.isLate = function (task) {
        return task.late;
    };
    TaskHelpers.isInOpenState = function (task) {
        return TaskHelpers.isTaskInOpenState(task) && TaskHelpers.isReadyToExecute(task);
    };
    TaskHelpers.isInPlanningState = function (task) {
        return TaskHelpers.isTaskInOpenState(task) && !TaskHelpers.isReadyToExecute(task);
    };
    TaskHelpers.isInClosedState = function (task) {
        return TaskHelpers.isDone(task);
    };
    TaskHelpers.isInvalid = function (task) {
        return task.invalidated === true;
    };
    return TaskHelpers;
}());
exports.TaskHelpers = TaskHelpers;
//# sourceMappingURL=TaskHelpers.js.map